module.exports = __webpack_public_path__ + "img/user_position.8d0e1cee.png";